import React from 'react'
import ReactDOM from 'react-dom/client';
import ShowableProductCardBadgeListV1 from 'ReactApp/Components/ShowableProductCardBadgeListV1/ShowableProductCardBadgeListV1';
import BuyViaCreditV1 from 'ReactApp/Components/BuyViaCreditV1/BuyViaCreditV1';
import BuyViaDolyameV1 from 'ReactApp/Components/BuyViaDolyameV1/BuyViaDolyameV1';
import DeliveryV1 from 'ReactApp/Components/DeliveryV1/DeliveryV1';
import MainCharacterListV1 from 'ReactApp/Components/MainCharacterListV1/MainCharacterListV1';
import PriceBlockV1 from 'ReactApp/Components/PriceBlockV1/PriceBlockV1';
import RealModifierSwitcherV1 from 'ReactApp/Components/RealModifierSwitcherV1/RealModifierSwitcherV1';
import TextileSwitcherV1 from 'ReactApp/Components/TextileSwitcherV1/TextileSwitcherV1';
import { showableProductCardInstance } from 'ReactApp/Ddd/Aggregates/ShowableProductCard'
import { ShowableProductCardHtmlIdentifierEnum } from 'ReactApp/Types/enum';
import LinkV1 from 'ReactApp/Components/LinkV1/LinkV1';
import RatingBlockV3 from 'ReactApp/Components/RatingBlockV3/RatingBlockV3';
import PopularInfoV1 from 'ReactApp/Components/PopularInfoV1/PopularInfoV1';
import StockV3 from 'ReactApp/Components/StockV3/StockV3';
import ArticulV1 from 'ReactApp/Components/ArticulV1/ArticulV1';
import BuyBlockV1 from 'ReactApp/Components/BuyBlockV1/BuyBlockV1';
import { AddToCompareV2 } from 'ReactApp/Components/AddToCompareV2/AddToCompareV2';
import { AddToWishListV2 } from 'ReactApp/Components/AddToWishListV2/AddToWishListV2';
import { SizeSelectorV1 } from 'ReactApp/Components/SizeSelectorV1/SizeSelectorV1';
import { TabPanelPriceBlockV1 } from 'ReactApp/Components/TabPanelPriceBlockV1/TabPanelPriceBlockV1';
import { ProductHeaderV1 } from 'ReactApp/Components/ProductHeaderV1/ProductHeaderV1';
import { AdditionalProductsV1 } from 'ReactApp/Components/AdditionalProductsV1/AdditionalProductsV1';
import { VisualProductPropertyGridV1 } from 'ReactApp/Components/VisualProductPropertyGridV1/VisualProductPropertyGridV1';
import { CharacterListV3 } from "ReactApp/Components/CharacterListV3/CharacterListV3";
import {biMarketingEventRunnerRun} from "../../../app/frontend/assets/js/services/bi/WithBiMarketingEventRunner";
import {MarketingEventTypeEnum} from "../../../app/frontend/assets/js/enums/MarketingEventTypeEnum";
import {MarketingEventVariableTypeEnum} from "../../../app/frontend/assets/js/enums/MarketingEventVariableTypeEnum";

showableProductCardInstance.initialize()
    .then(status => {
        // return;
        status === true
            ? enabledReactComponents()
            : disabledReactComponents()
    });

function enabledReactComponents(): void
{
    // запускаем маркетинговое событие. на просмотр карточки товара
    biMarketingEventRunnerRun({
        eventTypeId: MarketingEventTypeEnum.viewProductCard,
        dynamicData: {
            [MarketingEventVariableTypeEnum.marketingProductId]: showableProductCardInstance.marketingProductId,
            [MarketingEventVariableTypeEnum.productName]: showableProductCardInstance.title,
            [MarketingEventVariableTypeEnum.productPrice]: showableProductCardInstance.salePrice?.value,
            [MarketingEventVariableTypeEnum.currency]: showableProductCardInstance.currency ,
            [MarketingEventVariableTypeEnum.productBrand]: showableProductCardInstance.brand?.name,
            [MarketingEventVariableTypeEnum.productCategory]: showableProductCardInstance.category?.name,
        }
    });

    // virtual modifiers: textile
    let textileSwitcherContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.textileSwitcherWrapId
    }`) as (HTMLElement | null);
    if (textileSwitcherContainer !== null) {        
        const textileSwitcherRoot = ReactDOM.createRoot(textileSwitcherContainer);
        textileSwitcherRoot.render(
            <TextileSwitcherV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // buy via dolyame
    let buyViaDolyameContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.buyViaDolyameWrapId
    }`) as (HTMLElement | null);
    if (buyViaDolyameContainer !== null) {
        const buyViaDolyameRoot = ReactDOM.createRoot(buyViaDolyameContainer);
        buyViaDolyameRoot.render(
            <BuyViaDolyameV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // price block
    let priceBlockContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.priceBlockWrapId
    }`) as (HTMLElement | null);
    if (priceBlockContainer !== null) {
        const priceBlockRoot = ReactDOM.createRoot(priceBlockContainer);
        priceBlockRoot.render(
            <PriceBlockV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // stock
    let stockContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.stockWrapId
    }`) as (HTMLElement | null);
    if (stockContainer !== null) {
        const stockRoot = ReactDOM.createRoot(stockContainer);
        stockRoot.render(
            <StockV3 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    let articulContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.articulWrapId
    }`) as (HTMLElement | null);
    if (articulContainer !== null) {
        const articulRoot = ReactDOM.createRoot(articulContainer);
        articulRoot.render(
            <ArticulV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // buy via credit
    let buyViaCreditContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.buyViaCreditWrapId
    }`) as (HTMLElement | null);
    if (buyViaCreditContainer !== null) {
        const buyViaCreditRoot = ReactDOM.createRoot(buyViaCreditContainer);
        buyViaCreditRoot.render(
            <BuyViaCreditV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // delivery
    let deliveryContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.deliveryWrapId
    }`) as (HTMLElement | null);
    if (deliveryContainer !== null) {
        const deliveryRoot = ReactDOM.createRoot(deliveryContainer);
        deliveryRoot.render(
            <DeliveryV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // rating block
    let ratingBlockContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.ratingBlockWrapId
    }`) as (HTMLElement | null);
    if (ratingBlockContainer !== null) {
        const ratingBlockRoot = ReactDOM.createRoot(ratingBlockContainer);
        ratingBlockRoot.render(
            <>
                <RatingBlockV3 {...{
                    productCard: showableProductCardInstance
                }} />
                 <PopularInfoV1 {...{
                    productCard: showableProductCardInstance
                }} />
            </>
        );
    }

    //Subaction Group // likes and compare
    let subActionBlockContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.subActionGroupWrapId
    }`) as (HTMLElement | null);
    if (subActionBlockContainer !== null) {
        const subActionBlockRoot = ReactDOM.createRoot(subActionBlockContainer);
        subActionBlockRoot.render(
            <>
                 <AddToWishListV2 {...{
                    productCard: showableProductCardInstance
                }} />
                <AddToCompareV2 {...{
                    productCard: showableProductCardInstance
                }} />
            </>
        );
    }

    //size selector on tab panel
    let sizeSelectorBlockContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.sizeSelectorWrapId
    }`) as (HTMLElement | null);
    if (sizeSelectorBlockContainer !== null) {
        const sizeSelectorBlockRoot = ReactDOM.createRoot(sizeSelectorBlockContainer);
        sizeSelectorBlockRoot.render(
                 <SizeSelectorV1 {...{
                    productCard: showableProductCardInstance
                }} />
        );
    }

    // buy block - to cart/to favorite/ to compare / buy one click and more
    let buyBlockWrapContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.buyBlockWrapId
    }`) as (HTMLElement | null);
    if (buyBlockWrapContainer !== null) {
        const buyBlockWrapRoot = ReactDOM.createRoot(buyBlockWrapContainer);
        buyBlockWrapRoot.render(
            <BuyBlockV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // badge list
    let badgeListContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.badgeListWrapId
    }`) as (HTMLElement | null);
    if (badgeListContainer !== null) {
        const badgeListRoot = ReactDOM.createRoot(badgeListContainer);
        badgeListRoot.render(
            <ShowableProductCardBadgeListV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // popular character list
    let popularCharacterListContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.popularCharacterListWrapId
    }`) as (HTMLElement | null);
    if (popularCharacterListContainer !== null) {
        const popularCharacterListRoot = ReactDOM.createRoot(popularCharacterListContainer);
        popularCharacterListRoot.render(
            <VisualProductPropertyGridV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // main character list
    let mainCharacterListContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.mainCharacterListWrapId
    }`) as (HTMLElement | null);
    if (mainCharacterListContainer !== null) {
        const mainCharacterListRoot = ReactDOM.createRoot(mainCharacterListContainer);
        mainCharacterListRoot.render(
            <CharacterListV3 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // real modifier switcher
    let realModifierSwitcherContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.realModifierSwitcherWrapId
    }`) as (HTMLElement | null);
    if (realModifierSwitcherContainer !== null) {
        const realModifierSwitcherRoot = ReactDOM.createRoot(realModifierSwitcherContainer);
        realModifierSwitcherRoot.render(
            <>
                <RealModifierSwitcherV1 {...{
                    productCard: showableProductCardInstance
                }} />
                <LinkV1 
                    href="#" 
                    classes={['js-open-popup']} 
                    attributes={{
                        'data-popup': 'js-order-size-popup'
                    }} 
                    label="Заказать свой размер" 
                    />
            </>
        );
    }

    // additional real modifier switcher
    let additionalRealModifierSwitcherContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.additionalRealModifierWrapId
    }`) as (HTMLElement | null);
    if (additionalRealModifierSwitcherContainer !== null) {
        const additionalRealModifierSwitcherRoot = ReactDOM.createRoot(additionalRealModifierSwitcherContainer);
        additionalRealModifierSwitcherRoot.render(
            <>
                <RealModifierSwitcherV1 {...{
                    productCard: showableProductCardInstance
                }} />
            </>
        );
    }

    // tab panel price block
    let tabPanelPriceBlockContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.tabPanelPriceBlock
    }`) as (HTMLElement | null);
    if (tabPanelPriceBlockContainer !== null) {
        const tabPanelPriceBlockRoot = ReactDOM.createRoot(tabPanelPriceBlockContainer);
        tabPanelPriceBlockRoot.render(
            <TabPanelPriceBlockV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // productHeaderBlock
    let productHeaderBlockContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.productHeader
    }`) as (HTMLElement | null);
    if (productHeaderBlockContainer !== null) {
        const productHeaderBlockRoot = ReactDOM.createRoot(productHeaderBlockContainer);
        productHeaderBlockRoot.render(
            <ProductHeaderV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

    // additionalProduct
     let additionalProductsBlockContainer = document.querySelector(`#${
        ShowableProductCardHtmlIdentifierEnum.additionalProductsWrapId
    }`) as (HTMLElement | null);
    if (additionalProductsBlockContainer !== null) {
        const additionalProductsBlockRoot = ReactDOM.createRoot(additionalProductsBlockContainer);
        additionalProductsBlockRoot.render(
            <AdditionalProductsV1 {...{
                productCard: showableProductCardInstance
            }} />
        );
    }

}

function disabledReactComponents(): void
{
    // disabled components in the exists HTML from server-side app
}